// /global-context/domain-context.tsx
"use client";

import { createContext, useContext } from "react";

const DomainContext = createContext<string>("");

export function DomainContextWrapper({
  domain,
  children,
}: {
  domain: string;
  children: React.ReactNode;
}) {
  return (
    <DomainContext.Provider value={domain}>{children}</DomainContext.Provider>
  );
}

export function useDomainContext() {
  return useContext(DomainContext);
}
